import * as React from 'react';
import * as _ from 'lodash';
import { MaterialsFiltersContainer } from '../../StoneSetup/materialsFilter';
import { hashHistory } from 'react-router';
import { PARTS } from '../../../schemas/accessRightsModel';
export default function (props, context) {
    function onClick1(AR) {
        props.toggleShowAssignFeature();
    }
    function onClick2(AR) {
        props.collapseFeaturesFilters(!this.areFeaturesFiltersCollapsed);
    }
    function scopeAR3() {
        var AR = props.AR;
        return React.createElement('header', {}, React.createElement('div', { 'className': 'app-content-header app-content-header--buttons app-content-header--lined app-content-header--fixed' }, React.createElement('div', { 'className': 'app-content-header--buttons-left' }, React.createElement('button', {
            'className': 'ui-button4 ui-button4--blue ui-button4--large',
            'style': {
                width: 'auto',
                padding: '0 10px'
            }
        }, 'Select All'), React.createElement('button', {
            'className': 'ui-button4 ui-button4--blue ui-button4--large',
            'style': {
                width: 'auto',
                padding: '0 10px'
            }
        }, 'Deselect All \r\n            '), React.createElement('button', {
            'className': 'ui-button4 ui-button4--green',
            'onClick': onClick1.bind(this, AR)
        }, React.createElement('span', { 'className': 'ui-button4-icon ui-button-icon--arrow-down' }), React.createElement('span', {}, 'Assign SKU Filters'))), React.createElement('div', { 'className': 'app-content-header--buttons-right' }, React.createElement('button', {
            'className': 'ui-button4 ui-button4--blue ui-button4--large',
            'onClick': onClick2.bind(this, AR)
        }, '\r\n            Collapse\r\n            '))));
    }
    return scopeAR3.apply(this, []);
}